import { useAuthStore } from '../store/authStore';

/**
 * 利润可见性权限钩子（2026-09-08，PRD 4.3 L2）
 *
 * 数据来源：authStore.user.profit_visible（后端登录/资料响应下发，ADR-002 前端不自派生）
 * 兜底规则（K4 / R3）：undefined / null / 无用户 → 一律返回 false（保守拒绝展示利润），
 * 避免后端未升级或旧缓存用户误展示利润数据。
 *
 * 使用方式：
 *   const profitVisible = useProfitVisibility();
 *   {profitVisible && <CommissionCard />}
 */
export function useProfitVisibility(): boolean {
  const user = useAuthStore((state) => state.user);
  return user?.profit_visible === true;
}
